export default "__VITE_ASSET__CqRmTilO__"